import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  i18n: {
    componentheading: '',
    deliveryscopeheading: '',
    sizeheading: '',
    resultlistheading: '',
    weightlabel: '',
    maxweightlabel: '',
    maxmeasurementlabel: '',
    senddirectcta: '',
    stampshopcta: '',
  },
  market: {
    currency: '',
  },
});

export { state, onChange };
export default state;
